import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { login }      = useAuth();
  const navigate       = useNavigate();
  const [username, setU] = useState('');
  const [password, setP] = useState('');
  const [error, setErr]  = useState('');
  const [loading, setL]  = useState(false);

  const submit = async e => {
    e.preventDefault();
    setErr(''); setL(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setErr(err.response?.data?.error || 'Login failed');
    } finally { setL(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-title">SYS<span>MON</span></div>
        {error && <div className="login-error">[ {error} ]</div>}
        <form onSubmit={submit}>
          <div className="login-field">
            <label className="login-label">USERNAME</label>
            <input className="inp" value={username}
              onChange={e => setU(e.target.value)} autoFocus autoComplete="username" />
          </div>
          <div className="login-field">
            <label className="login-label">PASSWORD</label>
            <input className="inp" type="password" value={password}
              onChange={e => setP(e.target.value)} autoComplete="current-password" />
          </div>
          <button className="btn primary" type="submit" style={{ width: '100%', marginTop: 8 }}
                  disabled={loading}>
            {loading ? 'AUTHENTICATING...' : 'LOGIN'}
          </button>
        </form>
      </div>
    </div>
  );
}
